import { Country, Culture, Language } from './Global'
import { SimplifiedProduct } from './Product'
import { SimplifiedCategory } from './Taxonomy'

export const FilterKey = 'id' as const

// used by product search component
export interface SearchResult {
  products?: {
    data: SimplifiedProduct[]
    results: number
    total: number
  }
  categories?: {
    data: Array<SimplifiedCategory & { parentName?: string | number }>
    results: number
    total: number
  }
  searchString: string
  culture?: Culture
  includeAllCultures?: boolean
}

export type FilterOperator = 'equals' | 'includes' | 'range'

export interface FilterProperties {
  id: string
  name: string
  defaultName?: string
  matches?: number
  hasTerms?: boolean
  parentId?: string
  taxonomy?: string
  options?: FilterOption[]
  operator?: FilterOperator
}

export interface FilterOption extends FilterProperties {
  // used by ActiveFilters
  prefix?: string
  isWildCard?: boolean
  parentName?: string
}

export interface Filter extends FilterProperties {
  compareId?: string
  options: FilterOption[]

  // used by ActiveFilters
  country?: Country
  language?: Language
}

export interface CustomFilter {
  fieldPath: string[]
  operator: FilterOperator
  options: string[]
  active: boolean
}

export const NoneKey = '__none'
export const WildcardKey = '__any'
